/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { type FC } from 'react';

import Label from './Label';
import Input from './Input';
import type { Option } from '../../../index';
import { sumClasses } from '../../../../../utils/misc';

type OptionsProps = {
  name: string;
  options: Option[];
  value: string;
  hideRadio?: boolean;
  currentIndex: number;
  disabled?: boolean;
  updateValue: (val: any) => void;
};

const Options: FC<OptionsProps> = (props) => {
  const { name, options, value, hideRadio, updateValue, currentIndex, disabled } = props;

  return (
    <>
      {options.map((item: Option) => (
        <div
          key={`select_${name}_${item.value}`}
          {...{
            className: sumClasses([
              item.className || '',
              item.value === value ? item.selectedClassName || 'selected-radio' : '',
            ]),
            style: item.style,
          }}
        >
          <Input {...{ name, item, value, updateValue, disabled }} />
          <Label {...{ name, item, hideRadio, updateValue, value, currentIndex, options, disabled }} />
          {item.customSelectedIcon && item.value === value ? item.customSelectedIcon : null}
        </div>
      ))}
    </>
  );
};

export default Options;
